module.exports = __webpack_public_path__ + "static/media/14_Sandra_O@3x.62cc01d6.jpg";